@if (loading) {
  <span class="loading-animate height-xxxl width-max-300 width-full"></span>
  <span class="loading-animate height-xxxl width-140"></span>
} @else {
  <pagination-controls [(id)]="id" (pageChange)="changePage($event)" previousLabel="" nextLabel="" [responsive]="true"></pagination-controls>
  <select class="width-140 bg-white color-secondary-grey b-grey font-s pl-xs pr-xs pt-xxs pb-xxs hover-active-blue" [(ngModel)]="itemsPerPage" (ngModelChange)="changeItemsPerPage($event)" [ngModelOptions]="{standalone: true}">
    @for (option of paginationOptions; track option) { <option [ngValue]="option">Zeige {{option}} Einträge</option> }
    <!-- <option [ngValue]="totalCount">Zeige alle Einträge</option> -->
  </select>
}
